import { UiState, Snackbar } from './state'

export const getSnackbar = function (state: UiState): Snackbar {
  return state.snackbar
}
